'use client';

import { useTranslations } from 'next-intl';
import { DocsLinks } from '@/components/how-it-works/docs-links';
import { Award01Icon, ChartUpIcon, DollarCircleIcon } from '@/components/ui/icon/glyphs';
import { InfoModal } from '@/components/ui/info-modal';

interface PrizePoolHowItWorksModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PrizePoolHowItWorksModal({
  open,
  onOpenChange,
}: PrizePoolHowItWorksModalProps): React.ReactNode {
  const t = useTranslations('chart.prize_pool_how_it_works');

  return (
    <InfoModal
      open={open}
      onOpenChange={onOpenChange}
      size="lg"
      title={t('title')}
      description={t('description')}
      footer={<InfoModal.Footer cta={t('got_it')} onClose={(): void => onOpenChange(false)} />}
    >
      <InfoModal.IconList>
        <InfoModal.IconItem
          icon={ChartUpIcon}
          title={t('grows_title')}
          description={t('grows_description')}
        />
        <InfoModal.IconItem
          icon={Award01Icon}
          title={t('resolves_title')}
          description={t('resolves_description')}
        />
        <InfoModal.IconItem
          icon={DollarCircleIcon}
          title={t('share_title')}
          description={t('share_description')}
        />
      </InfoModal.IconList>
      <InfoModal.Callout>{t('info')}</InfoModal.Callout>
      <DocsLinks docsPath="/concepts/claims" />
    </InfoModal>
  );
}
